import $        from 'jquery';
import settings from '../settings';

export default () => {
    $('.channel-list__favourite').on('click', (ev) => {
        ev.preventDefault();

        let $me     = $(ev.currentTarget),
            $item   = $me.parents('.discover-list__item'),
            id      = $item.data('source-id'),
            verb    = ($me.hasClass('active'))?'DELETE':'POST';

        $.ajax({
            headers   : settings.api_headers,
	        url       : `/import/configurations/${id}/favourite`,
	        type      : verb
        })
        .success(() => $me.toggleClass('active'));
    });

    $('.sources-list__favourite').on('click', (ev) => {
        ev.preventDefault();

        let $me     = $(ev.currentTarget),
            $item   = $me.parents('tr'),
            id      = $item.data('id'),
            verb    = ($me.hasClass('active'))?'DELETE':'POST';

        $.ajax({
            headers   : settings.api_headers,
	        url       : `/import/configurations/${id}/favourite`,
	        type      : verb
        })
        .success(() => $me.toggleClass('active'));
    })
}
